import dayjs from "dayjs";
import { FormModel } from "../types/FormTypes";

export function mapFormDataToPayload(formData: FormModel) {
  const formatTimeToIso = (isoDate: string, timeRange: string) => {
    const [departure] = timeRange.split(" - ");
    const date = dayjs(isoDate).format("YYYY-MM-DD");
    return dayjs(`${date} ${departure}`, "YYYY-MM-DD HH:mm").toISOString();
  };

  const formatRoutePlace = (place: any, fallback?: any) => {
    const stopPointData = place?.OgtStopPointData;

    return {
      PlaceId: place?.Id ?? place?.PlaceId ?? fallback?.PlaceId ?? "",
      PlaceName: place?.PlaceName ?? fallback?.PlaceName ?? "",
      OgtType: sanitizeOgtType(place?.OgtType ?? fallback?.OgtType),

      ...(stopPointData
        ? {
            OgtStopPointData: {
              stopPointId: stopPointData.stopPointId ?? null,
              stopPointAlias: stopPointData.stopPointAlias ?? null,
              stopPointAliasId: stopPointData.stopPointAliasId ?? null,
            },
          }
        : {}),
    };
  };

  const formatArrivalToIso = (isoDate: string, timeRange: string) => {
    const [, arrival] = timeRange.split(" - ");
    const date = dayjs(isoDate).format("YYYY-MM-DD");
    return dayjs(`${date} ${arrival}`, "YYYY-MM-DD HH:mm").toISOString();
  };

  const sanitizeOgtType = (ogtType?: string): string => {
    return ogtType === "custom" || !ogtType ? "stop" : ogtType;
  };

  const formatPartialJourney = (journey: any): any => {
    var from = {
      PlaceId: journey.UsedStartPlace.Id || "",
      PlaceName: journey.UsedStartPlace?.PlaceName || journey.fromName || "",
      OgtType: sanitizeOgtType(journey.UsedStartPlace?.OgtType),
    };

    var to = {
      PlaceId: journey.UsedEndPlace.Id || "",
      PlaceName: journey.UsedEndPlace?.PlaceName || journey.toName || "",
      OgtType: sanitizeOgtType(journey.UsedEndPlace?.OgtType),
    };

    return {
      DateOfJourney: formatTimeToIso(
        journey.unformattedDate,
        journey.travelTime
      ),
      ArrivalDateOfJourney: formatArrivalToIso(
        journey.unformattedDate,
        journey.travelTime
      ),
      JourneyKey: journey.journeyKey,
      RouteLinks: Array.isArray(journey.line)
        ? journey.line.map((link: any, index: number) => ({
            DepDateTime: link.DepDateTime
              ? dayjs(link.DepDateTime).toISOString()
              : undefined,

            ArrDateTime: link.ArrDateTime
              ? dayjs(link.ArrDateTime).toISOString()
              : undefined,

            LineNrReal: link.Line?.LineNrReal,
            LineName: link.Line?.LineName,
            RunNo: link.Line?.RunNo,
            RouteLinkKey: link.RouteLinkKey ?? "",
            RouteLinkGroupType: link.Line?.Ogt?.OgtTrafficTypeGroupKey ?? "",

            From: formatRoutePlace(link.From, index === 0 ? from : undefined),

            To: formatRoutePlace(
              link.To,
              index === journey.line.length - 1 ? to : undefined
            ),
          }))
        : [],
      From: from,
      To: to,
    };
  };

  const payload = {
    ContactName: formData.contactperson ?? "",
    PhoneContact: formData.phonenumber ?? "",
    Email: formData.mailadress ?? "",
    OrganisationName: formData.schoolorg ?? "",
    PhoneOrganisation: formData.phonenumberschoolorg ?? "",
    NumTravelers: Number(formData.travelQty) || 0,
    PartialJourneys: [
      formatPartialJourney(formData.selectedJourney),
      ...(formData.traveltype === "round_trip" &&
      formData.selectedReturnJourney?.journeyKey
        ? [formatPartialJourney(formData.selectedReturnJourney)]
        : []),
    ],
  };

  return payload;
}
export type GroupTravelPayload = ReturnType<typeof mapFormDataToPayload>;
